import { logoutRoute } from "modules/auth";
import { circuitBreakerRoutes } from "modules/circuit-breaker";
import { dashboardRoutes } from "modules/dashboard";
import { payoutsRoutes } from "modules/payouts";
import { transactionsRoutes } from "modules/transactions";
import { userSettingsRoutes } from "modules/user-settings";

import { administrationRoutes } from "./administration";
import { configurationRoutes } from "./configuration";

import type { Route } from "./RouteModel";

const appRoutes: Route[] = [
  payoutsRoutes,
  dashboardRoutes,
  transactionsRoutes,
  userSettingsRoutes,
  logoutRoute,
  configurationRoutes,
  circuitBreakerRoutes,
  administrationRoutes,
];

export default appRoutes;
